import { render, staticRenderFns } from "./FormGetFlashSaleProductBySKU.vue?vue&type=template&id=8000b624&scoped=true&"
import script from "./FormGetFlashSaleProductBySKU.vue?vue&type=script&lang=js&"
export * from "./FormGetFlashSaleProductBySKU.vue?vue&type=script&lang=js&"
import style0 from "./FormGetFlashSaleProductBySKU.vue?vue&type=style&index=0&id=8000b624&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8000b624",
  null
  
)

export default component.exports